import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/routing/PrivateRoute';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import ReportLayout from './components/layout/ReportLayout';
import StudentReport from './components/reports/StudentReport';
import { Card, Typography } from 'antd';
import ExamPage from './components/exam/ExamPage';
import ExamSelection from './components/exam/ExamSelection';
import ExamHistory from './components/exam/ExamHistory';
import ExamResult from './components/exam/ExamResult';
// 导入新的MR考试报表组件
import MRExamReport from './components/reports/MRExamReport';
import MRExamSummaryReport from './components/reports/MRExamSummaryReport';
import RobotRepairReport from './components/reports/RobotRepairReport';

const { Title } = Typography;

// 简单的内联主页组件
const SimpleHome = () => (
  <Card>
    <Title level={2}>系统首页</Title>
    <p>欢迎使用安全培训考试系统</p>
  </Card>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* 登录路由 */}
          <Route path="/login" element={<Login />} />
          
          {/* 报表路由 - 使用报表专用布局 */}
          <Route 
            path="/reports/students" 
            element={
              <ReportLayout>
                <StudentReport />
              </ReportLayout>
            } 
          />
          
          {/* MR考试报表路由 */}
          <Route 
            path="/reports/mr-exams" 
            element={
              <MRExamReport />
            } 
          />
          
          {/* MR考试汇总报表路由 */}
          <Route 
            path="/reports/mr-summary" 
            element={
              <MRExamSummaryReport />
            } 
          />
          
          {/* MR工业机器人维修考试报表路由 */}
          <Route 
            path="/reports/robot-repair" 
            element={
              <RobotRepairReport />
            } 
          />
          
          {/* 修改根路由重定向 */}
          <Route path="/" element={<Navigate to="/selection" replace />} />
          
          {/* 考试相关路由 */}
          <Route path="/selection" element={
            <PrivateRoute>
              <ExamSelection />
            </PrivateRoute>
          } />
          <Route path="/exam" element={
            <PrivateRoute>
              <ExamPage />
            </PrivateRoute>
          } />
          <Route path="/history" element={
            <PrivateRoute>
              <ExamHistory />
            </PrivateRoute>
          } />
          <Route path="/result" element={
            <PrivateRoute>
              <ExamResult />
            </PrivateRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App; 